import React from "react";
import { StyledIcon } from "../StyledIcon";

const WrenchIcon = ({ icon, size, customProps, color = "#333333" }) => (
 <StyledIcon
  viewBox="0 0 36 36"
  a11yTitle={icon}
  color={color}
  size={size}
  {...customProps}  
>
    <title>489EA277-E7FF-4435-978F-6756E2AE109D@1x</title>
    <g
      id='Symbols'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='Build-black-36dp'>
        <path
          d='M34.05,28.5 L20.4,14.85 C21.75,11.4 21,7.35 18.15,4.5 C15.15,1.5 10.65,0.9 7.05,2.55 L13.5,9 L9,13.5 L2.4,7.05 C0.6,10.65 1.35,15.15 4.35,18.15 C7.2,21 11.25,21.75 14.7,20.4 L28.35,34.05 C28.95,34.65 29.85,34.65 30.45,34.05 L33.9,30.6 C34.65,30 34.65,28.95 34.05,28.5 Z'
          id='Path'
          fill={color}
        ></path>
      </g>
    </g>
  </StyledIcon>
);

export default WrenchIcon;